"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const FilterNode_1 = require("./FilterNode");
const DecisionNodeValidation_1 = require("../validations/DecisionNodeValidation");
class DecisionNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.Decision };
    if (props.type !== types_1.NODE_TYPES.Decision)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let defaultValue = {
      data: {
        expression: "( (c1) )",
        conditions: {
          c1: {
            id: "c1",
            type: types_1.FilterType.PARAM,
            key: "",
            value: "",
            operator: ""
          }
        }
      },
      onPositiveLookupResult: "pass"
    };
    if (nodeData) {
      let filter = new FilterNode_1.FilterNode();
      return {
        data: filter.deserialize(nodeData.data),
        onPositiveLookupResult: nodeData.onPositiveLookupResult
      };
    }
    return defaultValue;
  }
  serialize(uiData) {
    let filter = new FilterNode_1.FilterNode();
    return {
      data: filter.serialize(uiData.data),
      onPositiveLookupResult: uiData.onPositiveLookupResult
    };
  }
  getAttachedApis(selectedResource) {
    return this.getAttachedApisFromParent(selectedResource);
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: [this.getNodeName(), "Condition"].join("."),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources;
  }
  validate() {
    return new DecisionNodeValidation_1.DecisionNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.DecisionNode = DecisionNode;
//# sourceMappingURL=DecisionNode.js.map
